// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ResourcesPage from "../pages/Resources/Resources";
const __wvcRoutePaths = ["/ResourcesPage", "/resources"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["about-us", "aboutuspage", "compliance", "compliancepage", "contact", "contactpage", "core-services", "coreservicespage", "home", "homepage", "plant-equipment-hire", "plantequipmenthirepage", "post", "resources", "resourcespage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ResourcesPage />} />
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ResourcesPage />} />
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
